import { ComponentProps } from "react";
import { IComponentParent } from "sonobello.utilities.react";

import { ProtectedAppContextProvider } from "../../../AppContext";
import NoConfirmationNewPatientFlow, {
  PreQualifiedNoConfirmationNewPatientFlow
} from "../../Flows/Compositions/NoConfirmationNewPatientFlow";
import NoConfirmationNoBookFlow, {
  PreQualifiedNoConfirmationNoBookFlow
} from "../../Flows/Compositions/NoConfirmationNoBookFlow";
import NoConfirmationRebookFlow, {
  PreQualifiedNoConfirmationRebookFlow
} from "../../Flows/Compositions/NoConfirmationRebookFlow";
import FailoverFlowResolver from "../../Flows/Types/FailoverFlowResolver";
import NameMatchFlowResolver from "../../Flows/Types/NameMatchFlowResolver";
import PatientQualificationFlowResolver from "../../Flows/Types/PatientQualificationFlowResolver";
import ExperimentAssignmentAppContextProvider, {
  IExperimentAssignmentAppContextProviderProps
} from "../Components/ExperimentAssignmentAppContextProvider";
import useCreatePatientExperimentManualAuth from "../Hooks/UseCreatePatientExperiment";
import ExperimentContextValueProvider from "./ExperimentContextValueProvider";

const configuredExperimentAssignmentAppContextProvider: React.FC<
  IExperimentAssignmentAppContextProviderProps
> = props =>
  ExperimentAssignmentAppContextProvider({
    ...props,
    flowResolver: new FailoverFlowResolver([
      new PatientQualificationFlowResolver(
        props.session.patient.isPreviouslyQualified,
        new NameMatchFlowResolver([
          new PreQualifiedNoConfirmationNewPatientFlow(),
          new PreQualifiedNoConfirmationRebookFlow(),
          new PreQualifiedNoConfirmationNoBookFlow()
        ])
      ),
      new NameMatchFlowResolver([
        new NoConfirmationNewPatientFlow(),
        new NoConfirmationRebookFlow(),
        new NoConfirmationNoBookFlow()
      ])
    ]),
    useCreatePatientExperiment: useCreatePatientExperimentManualAuth,
    AppContext: ProtectedAppContextProvider
  });

const ExperimentContextAppContextProvider: React.FC<
  IComponentParent & Omit<IExperimentAssignmentAppContextProviderProps, "experimentContextProps">
> = ExperimentContextValueProvider<
  Pick<IExperimentAssignmentAppContextProviderProps, "experimentContextProps">,
  ComponentProps<typeof configuredExperimentAssignmentAppContextProvider>
>({
  Component: configuredExperimentAssignmentAppContextProvider,
  map: experimentContextProps => ({ experimentContextProps })
});

export default ExperimentContextAppContextProvider;
